import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MindMapImportComponent } from './handbook-import/mind-map-import/mind-map-import.component';
import { SystemObjectsImportComponent } from './system-objects-import/system-objects-import.component';
import { FormsModule } from '@angular/forms';
import { UtilitiesModule } from '@fi-app/utilities/utilities.module';
import { ImportSystemObjectService } from './system-objects-import/import-system-object.service';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MindMapImportService } from './handbook-import/mind-map-import/mind-map-import.service';
import { ComponentsModule } from '@fi-app/components/components.module';
import { FiSelectedFilesListModule } from '@fi-shared/selected-files-list/selected-files-list.module';
import { UIRouterModule } from '@uirouter/angular';
import { ImportStates } from '@fi-app/import/import-states';
import { FiCommentsSettingsModule } from '@fi-shared/fi-comments/fi-comments-settings';
import { FiHandbookImportComponent } from './handbook-import/handbook-import.component';
import { FiWordImportComponent } from './handbook-import/word-import/word-import.component';
import { DocumentModule } from '@fi-app/document/document.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatCardModule } from '@angular/material/card';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { FiWordExportComponent } from './handbook-import/fi-word-export/fi-word-export.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatRadioModule,
        MatCheckboxModule,
        ComponentsModule,
        UtilitiesModule,
        FiSelectedFilesListModule,
        UIRouterModule.forChild(ImportStates),
        FiCommentsSettingsModule,
        DocumentModule,
        MatProgressBarModule,
        MatCardModule,
        SelectSearchModule,
    ],
    declarations: [
        MindMapImportComponent,
        SystemObjectsImportComponent,
        FiHandbookImportComponent,
        FiWordImportComponent,
        FiWordExportComponent,
    ],
    providers: [ImportSystemObjectService, MindMapImportService],
})
export class ImportModule {}
